exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".critical-tooltip{max-width:340px!important}.critical-tooltip .tooltip-inner{background:rgba(0,0,0,.9);text-align:left}.critical-tooltip .tooltip-arrow{border-color:rgba(0,0,0,.9)}.critical-tooltip .critical-criteria{font-size:12px;line-height:1.35}.critical-tooltip .critical-criteria strong{color:#fff}.critical-tooltip .critical-criteria p{margin:6px 0}.critical-tooltip .critical-criteria ul{margin:0;padding-left:16px;list-style:disc}.critical-tooltip .critical-criteria li{margin-bottom:4px}.critical-tooltip .critical-criteria b{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b9507030","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/frpm/components/CriticalCasesCard.vue
// module id = 2145
// module chunks = 2